import {Component, HostListener, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {NeuralDissolveDirective} from "../../directives/particles.directive";
import {MatDialog} from "@angular/material/dialog";
import {LoginService} from "../login-dialog/services/login.service";
import {LoginDialogComponent} from "../login-dialog/login-dialog.component";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, NeuralDissolveDirective],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit{
  isScrolled = false;
  isSmartphone = false;
  activeSection: string = 'home';
  dropdownOpen: boolean = false;
  isLoggedIn = false;
  headerOffset = 50; // Ajustez selon la hauteur de votre header

  constructor(public dialog: MatDialog, private loginService: LoginService) {
  }

  ngOnInit(): void {
    // S'abonner à l'état d'authentification
    this.loginService.isAuthenticated$.subscribe(
      (isAuthenticated) => this.isLoggedIn = isAuthenticated
    );
    this.checkIfSmartphone();
  }
  openDropdown(): void {
    this.dropdownOpen = true;
  }

  closeDropdown(): void {
    this.dropdownOpen = false;
  }
  openLoginDialog(): void {
    this.dialog.open(LoginDialogComponent, {
      disableClose: true,  // Empêche la fermeture par clic en dehors
      panelClass: 'custom-dialog-container',  // Optionnel si tu veux utiliser un style Angular
    });
  }

  logout(): void{
    this.loginService.logout();
  }

  private checkIfSmartphone() {
    // Définit la largeur maximale pour un écran de smartphone
    this.isSmartphone = window.innerWidth <= 991; // ou utilise une autre valeur selon tes besoins
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    // Si on a scrollé plus de 50px, on change le style du header
    if (scrollPosition > 150) {
      this.isScrolled = true;
    } else {
      this.isScrolled = false;
    }

    const sections = document.querySelectorAll('section');
    let currentSection = '';

    sections.forEach(section => {
      const sectionTop = section.getBoundingClientRect().top;
      if (sectionTop <= 150 && sectionTop > -section.offsetHeight / 2) {
        currentSection = section.getAttribute('id') || '';
      }
    });

    if (currentSection) {
      this.activeSection = currentSection;
    }
  }

  scrollToSection(sectionId: string, event: Event): void {
    if(!this.isSmartphone) {
      event.preventDefault(); // Empêche le comportement par défaut de l'ancre
    }
    const section = document.getElementById(sectionId);
    if (section) {
      // Calculer la position exacte en tenant compte de l'offset
      const offsetPosition = section.getBoundingClientRect().top + window.scrollY - this.headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }

    // Mettre à jour l'URL sans recharger la page
    history.pushState(null, '', `#${sectionId}`);
  }
}
